import { Card } from "@components/cards/card";
import { ModalInfo } from "@components/modals/modal-info";
import { useModalContext } from "@hooks/contexts/modal-context";
import { IsLoading } from "@hooks/dtos/IHome";
import { IModalInfoDTO } from "@hooks/dtos/IModalInfoDTO";
import { Masks } from "@hooks/functions/Masks/Masks";
import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { api } from "@service/api";
import { useEffect, useState } from "react";
import { FaCircleInfo, FaDollarSign, FaMoneyBillTransfer, FaMoneyBillTrendUp } from "react-icons/fa6";
import Skeleton from "react-loading-skeleton";
import { useLocation } from "react-router-dom";

interface IModalInfoList {
    [key: string]: {
        header: string;
        title: string;
        text: string;
    };
}

interface ICustomerBalanceTmpDTO {
    credit: number,
    debit: number,
    balance: number
}

const masks = new Masks();
export function Dashboard() {
    const { client } = ZuAuthStore();

    const modalInfoList: IModalInfoList = {
        balance: {
            header: 'Saldo Disponível',
            title: 'Resumo Financeiro',
            text: 'Imprime o valor disponível para saque e demais transações financeiras na plataforma.',
        },
        credits: {
            header: 'Crédito Total',
            title: 'Crédito Geral',
            text: 'Imprime o valor recebido ou inserido na Plataforma, incluindo recebido de terceiros por interações, pagamentos e/ou depósitos próprios.',
        },
        debits: {
            header: 'Débito Total',
            title: 'Débito Geral',
            text: 'Imprime o valor enviado ou retirado (sacado) na Plataforma, incluindo pagamentos de interações a terceiros, etc...',
        }
    };
    
    const location = useLocation();
    const { changeHash } = useModalContext();

    const [ modalInfo, setModalInfo ] = useState<IModalInfoDTO>({
        header: ``,
        title: ``,
        text: ``,
    });
    
    const { actions: { pushToastify } } = ZuToastifyStore()

    const [ isLoading, setIsLoading ] = useState<IsLoading>({
        financial: true,
        coinextSnapShot: true
    });

    function getModalInfo(param: string) {
        const info = modalInfoList[param];
        if (!info) {
            pushToastify({
                message: `Houve um erro ao carregar as informações.`,
                type: 'warning',
                theme: "dark",
            });
            return;
        }
        
        setModalInfo({
            header: info.header,
            title: info.title,
            text: info.text,
        });

        OpenModal();
    }

    function OpenModal() {
        changeHash("modalInfo")
    }

    function inMaintenance() {
        pushToastify({
            message: `Em construção.`,
            type: 'info',
            theme: "dark",
        });
    }

    return (
        <>
            {/* Financial Summary */}
            <div className="row">
                
                {/* Balance */}
                <div className="col-md-4">
                    <Card className="position-relative">
                        <div className="card-header">
                            <div className="card-title">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        Saldo Disponível
                                    </div>
                                    <div>
                                        <button className="btn p-0 fs-5" onClick={() => getModalInfo("balance")}><FaCircleInfo /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                        </div>
                    </Card>
                </div>

                {/* Credit */}
                <div className="col-md-4">
                    <Card className="position-relative">
                        <div className="card-header">
                            <div className="card-title">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        Créditos
                                    </div>
                                    <div>
                                        <button className="btn p-0 fs-5" onClick={() => getModalInfo("credits")}><FaCircleInfo /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                        </div>
                    </Card>
                </div>

                {/* Debit */}
                <div className="col-md-4">
                    <Card className="position-relative">
                        <div className="card-header">
                            <div className="card-title">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        Débitos
                                    </div>
                                    <div>
                                        <button className="btn p-0 fs-5" onClick={() => getModalInfo("debits")}><FaCircleInfo /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                        </div>
                    </Card>
                </div>
            </div>

            <ModalInfo
                header={modalInfo.header}
                title={modalInfo.title}
                text={modalInfo.text}
                isOpen={location?.hash === '#modalInfo'}
                onClose={() => {
                    changeHash('');
                }}
            />
        </>
    );
}